module.exports = __webpack_public_path__ + "img/product43_img04.bd1e3320.png";